import _ from "lodash";

import IAppReducer from "models/IAppReducer";
import { actionTypes } from "./actions";
import { Reducer } from "redux";
import produce from "immer";

const initialState: IAppReducer = {
  user: null,
  isAppLoading: false,
  sessionExpired: false,
  accountMessages: [],
  currentCustomer: JSON.parse(localStorage.getItem("customer") || "{}"),
  userName: localStorage.getItem("userName"),
  roles: [],
  customers: [],
  roleIds: [],
  meta: {
    currentPage: 0
  },
  messageTypes: {}
};
export interface ICustomAction {
  payload: any;
  type: any;
}

const costumeAction: Reducer<IAppReducer, ICustomAction> = (
  state = initialState,
  action: any
) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.USER_FOUND: {
        const { roles, user } = action.payload;
        draftState.user = user;
        draftState.sessionExpired = false;
        draftState.isAppLoading = false;
        draftState.roles = roles;
        break;
      }
      case actionTypes.SET_APP_LOADING:
        draftState.isAppLoading = action.payload.isAppLoading;
        break;
      case actionTypes.GET_CUSTOMERS_REQUEST:
        draftState.customers = action.payload ? [] : state.customers;
        draftState.isAppLoading = true;
        break;
      case actionTypes.GET_CUSTOMERS_SUCCESS:
        const { meta, customer } = action.payload;
        draftState.isAppLoading = false;
        draftState.customers = customer;
        draftState.meta = meta;
        draftState.currentCustomer =
          _.find(customer, ["Id", state.currentCustomer.Id]) ||
          state.currentCustomer;
        break;
      case actionTypes.GET_CUSTOMERS_FAILURE:
        return initialState;
      case actionTypes.GET_ACCOUNT_MESSAGES_REQUEST:
        draftState.isAppLoading = true;
        break;
      case actionTypes.GET_ACCOUNT_MESSAGES_SUCCESS:
        draftState.isAppLoading = false;
        draftState.accountMessages = action.payload;
        break;
      case actionTypes.GET_ACCOUNT_MESSAGES_FAILURE:
        return initialState;
      case actionTypes.GET_ROLE_IDS_REQUEST:
        draftState.isAppLoading = true;
        break;
      case actionTypes.GET_ROLE_IDS_SUCCESS:
        draftState.isAppLoading = false;
        draftState.roleIds = action.payload;
        break;
      case actionTypes.GET_ROLE_IDS_FAILURE:
        return initialState;
      case actionTypes.GET_MESSAGE_TYPES_REQUEST:
        draftState.isAppLoading = true;
        break;
      case actionTypes.GET_MESSAGE_TYPES_SUCCESS:
        draftState.isAppLoading = false;
        draftState.messageTypes = action.payload;
        break;
      case actionTypes.GET_MESSAGE_TYPES_FAILURE:
        draftState.isAppLoading = false;
        break;
      case actionTypes.LOGOUT_USER_ACCOUNT: {
        return initialState;
      }
    }
  });

export default costumeAction;
